<template>
  <div>
    <h1 class="font-medium text-5xl pb-5 tracking-wide xl:text-6xl">{{ $t('name') }}</h1>
    <h2 class="text-2xl tracking-wider uppercase xl:text-3xl">{{ $t('job') }}</h2>
  </div>
</template>
